export default __webpack_public_path__ + "21f3002c55d3aaf5c55cf0934aac24ca.svg";